export default () => ({
  item: {},
  items: []
})
